import { NavLink as RouterNavLink } from "react-router-dom";
import styled, { css } from "styled-components";

export const Title = styled.h1`
  ${({
    theme,
    transform,
    size,
    color = "primary",
    titlePosition,
    widthFull,
  }) => css`
    color: ${theme.colors.info[color]};
    font: ${`${size ? theme.font.size[size] : theme.font.size.medium} ${
      theme.font.family.bold
    }`};
    max-width: ${widthFull ? "unset" : "300px"};
    text-align: ${titlePosition === "left" ? "left" : "center"};
    text-transform: ${`${transform ? "uppercase" : "none"}`};
  `}
`;

export const MerchantName = styled.h1`
  ${({ theme, color = "light" }) => css`
    color: ${theme.colors.info[color]};
    font-size: ${`${theme.font.size.xSmall}`};
    max-width: 300px;
    position: absolute;
    left: 20px;
    text-transform: uppercase;
  `}
`;

export const Paragraph = styled.p`
  ${({ theme, size, color = "primary", indent, justify }) => css`
    color: ${theme.colors.info[color]};
    font: ${`${size ? theme.font.size[size] : theme.font.size.small} ${
      theme.font.family.primary
    }`};
    padding-left: ${indent ? "1.5rem" : "0"};
    text-align: ${justify ? "justify" : "center"};

    strong {
      font: ${`${size ? theme.font.size[size] : theme.font.size.small} ${
        theme.font.family.bold
      }`};
    }
  `}
`;

export const NavLink = styled(RouterNavLink)`
  color: ${({ theme }) => theme.colors.info.primary};
  font: ${({ theme }) =>
    `${theme.font.size.small} ${theme.font.family.primary}`};
  line-height: 200%;
  margin: 0 5px;

  &.${({ activeClassName }) => activeClassName} {
    color: ${({ theme }) => theme.colors.info.light};
    font-weight: 600;
  }
`;
